import { featured } from '@/mocks/manga';
import MangaCard from './MangaCard';
import type { MangaItem } from '@/mocks/manga';

interface Props {
  query: string;
  onOpen: (item: MangaItem) => void;
}

export default function Featured({ query, onOpen }: Props) {
  const keyword = query.trim().toLowerCase();
  const list = keyword
    ? featured.filter(
        (m) =>
          m.title.toLowerCase().includes(keyword) ||
          m.altTitle.toLowerCase().includes(keyword) ||
          m.category.toLowerCase().includes(keyword) ||
          m.desc.toLowerCase().includes(keyword),
      )
    : featured;

  return (
    <section id="featured" className="mx-auto w-full max-w-[1200px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-fire-fill text-primary-500"></i>
            火热连载
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">热门连载 · 追更首选</h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            精选人气口碑俱佳的作品，独家汉化、抢先看与未删减高清原版同步放送。
          </p>
        </div>
        <div className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-xs text-foreground-600">
          <i className="ri-refresh-line text-accent-500"></i>
          今日已同步 {list.length * 6 + 18} 章新内容
        </div>
      </div>

      {list.length === 0 ? (
        <div className="mt-10 flex flex-col items-center rounded-2xl border border-dashed border-background-300 bg-background-100 py-16 text-center">
          <i className="ri-search-eye-line text-4xl text-foreground-400"></i>
          <p className="mt-3 text-sm font-medium text-foreground-700">没有找到「{query.trim()}」相关的连载</p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="mt-4 inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600"
          >
            换个关键词再搜
          </button>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {list.map((item) => (
            <MangaCard key={item.id} item={item} onOpen={onOpen} />
          ))}
        </div>
      )}
    </section>
  );
}